import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

/** List row: flex, 15px vertical padding, a stripeA hairline underneath. Rows,
 * not cards, separate list items. */
export function Row({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('flex items-center gap-4 border-b border-stripeA py-[15px]', className)} {...props} />;
}
